import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const updateUpdatedUserKey = 'updateUpdatedUser';

export interface UpdateUpdatedUserState {
  updateUpdatedUserResponse: any;
  updateUpdatedUserFailure: any;
  loaded: boolean;
}

export const initialState: UpdateUpdatedUserState = {
  updateUpdatedUserResponse: undefined,
  updateUpdatedUserFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.updateUpdatedUserSuccess, (state, action) => ({
    ...state,
    updateUpdatedUserResponse: action.response,
    loaded: true
  })),

  on(actions.updateUpdatedUserFailure, (state, action) => ({
    ...state,
    updateUpdatedUserFailure: action.error
  }))
);

export const updateUpdatedUser = (state: UpdateUpdatedUserState) => state.updateUpdatedUserResponse;
